/**
 * 管理员
 */
class DZModelManager {

    /**
     * 主键
     */
    id = "";

    /**
     * 账号
     */
    account = "";

    /**
     * 管理员名称
     */
    name = "";

    /**
     * 角色ID
     */
    roleId = "";

    roleIds = [];

    /**
     * 角色名称
     */
    roleName = "";

}

export default DZModelManager;
